module.exports = __webpack_public_path__ + "img/tabs1-3.7a23fc43.png";